require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-adam-dsylva.json") })
        }
      }, "path---news-adam-dsylva");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-adam-dsylva!./.cache/json/news-adam-dsylva.json
// module id = 783
// module chunks = 231608221292675